import Layout from "../../../components/layout/layout.js";

import TicketForm from "../../../components/form/ticket.form";

function TicketPage({ component, ...rest }) {
  return <Layout Component={TicketForm} {...rest} />;
}

export default TicketPage;
